export default __webpack_public_path__ + "static/media/grafema_angura_08.5b6cafe4.jpg";